import Logo from '@/assets/Logo.svg?react';
import LogoMini from '@/assets/LogoMini.svg?react';
import { useProfileOnboarding } from '@/context/OnboarrdingContext';
import { GoogleLogin } from '@react-oauth/google';
import { UserMenu } from '@/components/UserMenu';

export function Layout({ children }: { children: React.ReactNode }) {
  const { authUser, handleGoogleSuccess, logout } = useProfileOnboarding();

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white shadow-card">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <span className="w-auto hidden md:block">
                <Logo className="h-8" />
              </span>
              <span className="w-auto md:hidden">
                <LogoMini className="h-8" />
              </span>
            </div>
            <div className="flex items-center">
              {authUser ? (
                <UserMenu user={authUser} onLogout={logout} />
              ) : (
                <GoogleLogin
                  onSuccess={handleGoogleSuccess}
                  onError={() => {
                    console.error('Google Login Failed');
                  }}
                  useOneTap
                />
              )}
            </div>
          </div>
        </div>
      </header>
      <main>{children}</main>
    </div>
  );
}
